import { useEffect, useState, useRef, useCallback } from 'react';
import './App.css';

// Full Daiwa Ecosystem Data - SUPER WIDE SPREAD OUT VERSION
const createFullEcosystem = () => {
  const nodes = new Map([
    // COLUMN 1: Legacy & AI (Far Left)
    ['nav', { id: 'nav', type: 'legacy', x: 50, y: 600, width: 140, height: 70, label: 'NAV On-Prem', category: 'Legacy ERP', icon: '🏢', status: 'legacy' }],
    ['ai', { id: 'ai', type: 'building', x: 50, y: 400, width: 150, height: 70, label: 'AI Data Ready', category: 'Innovation', icon: '🤖', status: 'building' }],
    
    // COLUMN 2: Cloud Infrastructure Entry Points
    ['cdn', { id: 'cdn', type: 'live', x: 300, y: 200, width: 140, height: 70, label: 'Azure CDN', category: 'Content Delivery', icon: '🌐', status: 'live' }],
    ['api', { id: 'api', type: 'live', x: 300, y: 320, width: 140, height: 70, label: 'BC API Gateway', category: 'API Management', icon: '🔌', status: 'live' }],
    ['loadbalancer', { id: 'loadbalancer', type: 'live', x: 300, y: 450, width: 150, height: 70, label: 'Load Balancer', category: 'Traffic Distribution', icon: '⚖️', status: 'live' }],
    
    // COLUMN 3: Azure Platform
    ['azure', { id: 'azure', type: 'central', x: 550, y: 320, width: 180, height: 80, label: 'Microsoft Azure', category: 'Cloud Platform', icon: '🔷', status: 'live' }],
    
    // COLUMN 4: Application Tier
    ['appserver1', { id: 'appserver1', type: 'live', x: 850, y: 250, width: 150, height: 70, label: 'App Server 1', category: 'Application Tier', icon: '🖥️', status: 'live' }],
    ['appserver2', { id: 'appserver2', type: 'live', x: 850, y: 380, width: 150, height: 70, label: 'App Server 2', category: 'Application Tier', icon: '🖥️', status: 'live' }],
    
    // COLUMN 5: Database
    ['sqldb', { id: 'sqldb', type: 'central', x: 1150, y: 310, width: 170, height: 80, label: 'Azure SQL Database', category: 'Database Tier', icon: '🗄️', status: 'live' }],
    
    // COLUMN 6: Business Central Hub (Center)
    ['bc', { id: 'bc', type: 'central', x: 1450, y: 300, width: 220, height: 100, label: 'Business Central', category: 'Cloud ERP Hub', icon: '☁️', status: 'live' }],
    
    // COLUMN 7: WMS (Right of BC)
    ['starshipit', { id: 'starshipit', type: 'live', x: 1800, y: 200, width: 160, height: 70, label: 'Starshipit', category: 'WMS Shipping', icon: '📦', status: 'live' }],
    ['tasklest', { id: 'tasklest', type: 'planned', x: 2050, y: 200, width: 160, height: 70, label: 'Tasklest', category: 'WMS Tasks', icon: '📋', status: 'planned' }],
    
    // COLUMN 8: Carriers (Right of WMS)
    ['directfreight', { id: 'directfreight', type: 'third-party', x: 2350, y: 150, width: 150, height: 70, label: 'Direct Freight', category: 'Carrier Partner', icon: '🚚', status: 'live' }],
    ['startrac', { id: 'startrac', type: 'third-party', x: 2350, y: 250, width: 130, height: 70, label: 'Startrac', category: 'Carrier Partner', icon: '✈️', status: 'live' }],
    ['auspost', { id: 'auspost', type: 'third-party', x: 2350, y: 350, width: 130, height: 70, label: 'AusPost', category: 'Carrier Partner', icon: '✉️', status: 'live' }],
    
    // COLUMN 9: Factory/Upstream (Below BC area)
    ['dittdoss', { id: 'dittdoss', type: 'third-party', x: 1800, y: 450, width: 160, height: 70, label: 'DITT & DOSS', category: 'Factory Salesforce', icon: '🏭', status: 'live' }],
    
    // COLUMN 10: EDI & Retail (Far Right Top)
    ['edi', { id: 'edi', type: 'live', x: 2650, y: 250, width: 150, height: 70, label: 'EDI Module', category: 'EDI Integration', icon: '🔄', status: 'live' }],
    ['bcf', { id: 'bcf', type: 'live', x: 2900, y: 200, width: 120, height: 70, label: 'BCF', category: 'Retail Client', icon: '🏪', status: 'live' }],
    ['anaconda', { id: 'anaconda', type: 'live', x: 2900, y: 320, width: 140, height: 70, label: 'Anaconda', category: 'Retail Client', icon: '🏪', status: 'live' }],
    
    // COLUMN 11: Cloudflare Integration (Below EDI area)
    ['cfworker', { id: 'cfworker', type: 'live', x: 2650, y: 450, width: 170, height: 70, label: 'CF Worker + D1', category: 'Cloudflare Middleware', icon: '⚡', status: 'live' }],
    ['shopifymodule', { id: 'shopifymodule', type: 'live', x: 2650, y: 550, width: 170, height: 70, label: 'Shopify Module', category: 'BC Extension', icon: '🛒', status: 'live' }],
    
    // COLUMN 12: E-commerce Platforms (Far Right)
    ['shopifyb2b', { id: 'shopifyb2b', type: 'live', x: 2950, y: 450, width: 160, height: 70, label: 'Shopify B2B', category: 'Wholesale Store', icon: '🏪', status: 'live' }],
    ['shopifyb2c', { id: 'shopifyb2c', type: 'live', x: 2950, y: 550, width: 160, height: 70, label: 'Shopify B2C', category: 'Consumer Store', icon: '📱', status: 'live' }],
    
    // COLUMN 13: B2B/B2C Portals (Right of E-commerce)
    ['b2binternal', { id: 'b2binternal', type: 'child', x: 3200, y: 420, width: 150, height: 70, label: 'B2B Internal', category: 'Internal Portal', icon: '🌐', status: 'live' }],
    ['b2bexternal', { id: 'b2bexternal', type: 'child', x: 3200, y: 520, width: 150, height: 70, label: 'B2B External', category: 'External Portal', icon: '🌍', status: 'live' }],
    ['dyfc', { id: 'dyfc', type: 'child', x: 3200, y: 620, width: 150, height: 70, label: 'DYFC App', category: 'Consumer App', icon: '📷', status: 'live' }],
    
    // BOTTOM ROW: Internal Tools (Below everything)
    ['daiwahub', { id: 'daiwahub', type: 'live', x: 1450, y: 700, width: 160, height: 70, label: 'Daiwa Hub', category: 'Internal Tool', icon: '🔧', status: 'live' }],
    ['budget', { id: 'budget', type: 'building', x: 1700, y: 700, width: 170, height: 70, label: 'Budget & Forecast', category: 'Internal Tool', icon: '📈', status: 'building' }],
    ['dashboard', { id: 'dashboard', type: 'building', x: 1950, y: 700, width: 160, height: 70, label: 'Dashboard', category: 'Internal Tool', icon: '📊', status: 'building' }],
    ['companycalendar', { id: 'companycalendar', type: 'live', x: 2200, y: 700, width: 180, height: 70, label: 'Company Calendar', category: 'Internal Tool', icon: '📅', status: 'live' }],
    
    // BOTTOM ROW 2: Finance (Far bottom)
    ['continia', { id: 'continia', type: 'live', x: 1450, y: 850, width: 160, height: 70, label: 'Continia', category: 'Finance & Docs', icon: '📄', status: 'live' }],
    ['employmenthero', { id: 'employmenthero', type: 'loose', x: 1700, y: 850, width: 180, height: 70, label: 'Employment Hero', category: 'HR Platform', icon: '👤', status: 'loose' }],
    
    // BOTTOM ROW 3: Banking (Far bottom right)
    ['westpac', { id: 'westpac', type: 'planned', x: 2000, y: 850, width: 160, height: 70, label: 'Westpac Feed', category: 'Bank Integration', icon: '🏦', status: 'planned' }],
    ['siss', { id: 'siss', type: 'planned', x: 2250, y: 850, width: 140, height: 70, label: 'SISS', category: 'Bank Connector', icon: '🔗', status: 'planned' }],
  ]);

  // All connections - widely spaced with animated dots
  const connections = new Map([
    // COLUMN 1 -> 2: Legacy/AI to Infrastructure Entry
    ['c-ai-api', { id: 'c-ai-api', fromId: 'ai', toId: 'api', color: 'purple', width: 2, label: 'AI', dashed: true, animated: true }],
    
    // COLUMN 2 -> 3: Entry Points to Azure
    ['c-cdn-lb', { id: 'c-cdn-lb', fromId: 'cdn', toId: 'loadbalancer', color: 'blue', width: 1.5, animated: true }],
    ['c-api-lb', { id: 'c-api-lb', fromId: 'api', toId: 'loadbalancer', color: 'blue', width: 1.5, animated: true }],
    ['c-lb-azure', { id: 'c-lb-azure', fromId: 'loadbalancer', toId: 'azure', color: 'blue', width: 2, label: 'ROUTE', animated: true }],
    
    // COLUMN 3 -> 4: Azure to App Servers
    ['c-azure-app1', { id: 'c-azure-app1', fromId: 'azure', toId: 'appserver1', color: 'blue', width: 1.8, label: 'SCALE', animated: true }],
    ['c-azure-app2', { id: 'c-azure-app2', fromId: 'azure', toId: 'appserver2', color: 'blue', width: 1.8, label: 'SCALE', animated: true }],
    
    // COLUMN 4 -> 5: App Servers to Database
    ['c-app1-sql', { id: 'c-app1-sql', fromId: 'appserver1', toId: 'sqldb', color: 'blue', width: 2, label: 'DATA', animated: true }],
    ['c-app2-sql', { id: 'c-app2-sql', fromId: 'appserver2', toId: 'sqldb', color: 'blue', width: 2, label: 'DATA', animated: true }],
    
    // COLUMN 5 -> 6: Database to BC Hub
    ['c-sql-bc', { id: 'c-sql-bc', fromId: 'sqldb', toId: 'bc', color: 'blue', width: 3, label: 'HOST', animated: true }],
    
    // LEGACY -> BC: Migration
    ['c-nav-bc', { id: 'c-nav-bc', fromId: 'nav', toId: 'bc', color: 'gold', width: 3, label: 'MIGRATED', animated: true }],
    
    // COLUMN 6 -> 7: BC to WMS
    ['c-bc-starship', { id: 'c-bc-starship', fromId: 'bc', toId: 'starshipit', color: 'green', width: 2.5, label: 'ORDERS', animated: true }],
    ['c-starship-task', { id: 'c-starship-task', fromId: 'starshipit', toId: 'tasklest', color: 'green', width: 1.5, animated: true }],
    
    // COLUMN 7 -> 8: WMS to Carriers
    ['c-starship-freight', { id: 'c-starship-freight', fromId: 'starshipit', toId: 'directfreight', color: 'purple', width: 2, animated: true }],
    ['c-starship-startrac', { id: 'c-starship-startrac', fromId: 'starshipit', toId: 'startrac', color: 'purple', width: 2, animated: true }],
    ['c-starship-auspost', { id: 'c-starship-auspost', fromId: 'starshipit', toId: 'auspost', color: 'purple', width: 2, animated: true }],
    
    // COLUMN 6 -> 9: BC to Factory
    ['c-bc-factory', { id: 'c-bc-factory', fromId: 'bc', toId: 'dittdoss', color: 'purple', width: 2.5, label: 'FACTORY', animated: true }],
    
    // COLUMN 6 -> 10: BC to EDI/Retail
    ['c-bc-edi', { id: 'c-bc-edi', fromId: 'bc', toId: 'edi', color: 'amber', width: 2.5, label: 'EDI', animated: true }],
    ['c-edi-bcf', { id: 'c-edi-bcf', fromId: 'edi', toId: 'bcf', color: 'amber', width: 2, animated: true }],
    ['c-edi-anaconda', { id: 'c-edi-anaconda', fromId: 'edi', toId: 'anaconda', color: 'amber', width: 2, animated: true }],
    
    // COLUMN 6 -> 11: BC to Cloudflare Integration
    ['c-bc-cfworker', { id: 'c-bc-cfworker', fromId: 'bc', toId: 'cfworker', color: 'teal', width: 2.5, label: 'SYNC', animated: true }],
    ['c-bc-shopifymod', { id: 'c-bc-shopifymod', fromId: 'bc', toId: 'shopifymodule', color: 'teal', width: 2, label: 'CATALOG', animated: true }],
    
    // COLUMN 11 -> 12: Integration to Shopify
    ['c-cf-b2b', { id: 'c-cf-b2b', fromId: 'cfworker', toId: 'shopifyb2b', color: 'teal', width: 2, label: 'ORDERS', animated: true }],
    ['c-cf-b2c', { id: 'c-cf-b2c', fromId: 'cfworker', toId: 'shopifyb2c', color: 'teal', width: 2, label: 'ORDERS', animated: true }],
    ['c-mod-b2b', { id: 'c-mod-b2b', fromId: 'shopifymodule', toId: 'shopifyb2b', color: 'teal', width: 1.5, label: 'PRODUCTS', animated: true }],
    ['c-mod-b2c', { id: 'c-mod-b2c', fromId: 'shopifymodule', toId: 'shopifyb2c', color: 'teal', width: 1.5, label: 'PRODUCTS', animated: true }],
    
    // COLUMN 12 -> 13: Shopify to Portals
    ['c-b2b-internal', { id: 'c-b2b-internal', fromId: 'shopifyb2b', toId: 'b2binternal', color: 'teal', width: 1.5, animated: true }],
    ['c-b2b-external', { id: 'c-b2b-external', fromId: 'shopifyb2b', toId: 'b2bexternal', color: 'teal', width: 1.5, animated: true }],
    ['c-b2c-dyfc', { id: 'c-b2c-dyfc', fromId: 'shopifyb2c', toId: 'dyfc', color: 'teal', width: 1.5, animated: true }],
    
    // BC -> BOTTOM ROW: Internal Tools
    ['c-bc-hub', { id: 'c-bc-hub', fromId: 'bc', toId: 'daiwahub', color: 'green', width: 2, label: 'DATA', animated: true }],
    ['c-bc-budget', { id: 'c-bc-budget', fromId: 'bc', toId: 'budget', color: 'green', width: 2, label: 'DATA', animated: true }],
    ['c-bc-dash', { id: 'c-bc-dash', fromId: 'bc', toId: 'dashboard', color: 'green', width: 2, label: 'DATA', animated: true }],
    ['c-bc-cal', { id: 'c-bc-cal', fromId: 'bc', toId: 'companycalendar', color: 'green', width: 2, label: 'EVENTS', animated: true }],
    
    // BC -> BOTTOM ROW 2: Finance
    ['c-bc-continia', { id: 'c-bc-continia', fromId: 'bc', toId: 'continia', color: 'orange', width: 2.5, label: 'FINANCE', animated: true }],
    ['c-bc-hr', { id: 'c-bc-hr', fromId: 'bc', toId: 'employmenthero', color: 'orange', width: 1.5, label: 'HR', dashed: true, animated: true }],
    
    // BOTTOM ROW 3: Banking to Continia
    ['c-westpac-cont', { id: 'c-westpac-cont', fromId: 'westpac', toId: 'continia', color: 'purple', width: 2, label: 'BANK', dashed: true, animated: true }],
    ['c-siss-cont', { id: 'c-siss-cont', fromId: 'siss', toId: 'continia', color: 'purple', width: 2, label: 'BANK', dashed: true, animated: true }],
  ]);

  const zones = new Map([
    // ZONE 1: Legacy (Far Left)
    ['legacy', { id: 'legacy', x: 30, y: 350, width: 200, height: 350, label: 'LEGACY SYSTEMS', color: 'rgba(68,85,102,0.6)', fillColor: 'rgba(68,85,102,0.1)' }],
    
    // ZONE 2: Cloud Infrastructure (Columns 2-5)
    ['cloudinfra', { id: 'cloudinfra', x: 270, y: 150, width: 1080, height: 300, label: 'AZURE CLOUD INFRASTRUCTURE', color: 'rgba(58,134,255,0.5)', fillColor: 'rgba(58,134,255,0.08)' }],
    
    // ZONE 3: BC Hub (Column 6)
    ['bchub', { id: 'bchub', x: 1410, y: 270, width: 300, height: 160, label: 'BUSINESS CENTRAL HUB', color: 'rgba(255,209,102,0.5)', fillColor: 'rgba(255,209,102,0.1)' }],
    
    // ZONE 4: WMS & Carriers (Columns 7-8)
    ['logistics', { id: 'logistics', x: 1750, y: 100, width: 800, height: 350, label: 'LOGISTICS & CARRIERS', color: 'rgba(6,214,160,0.5)', fillColor: 'rgba(6,214,160,0.08)' }],
    
    // ZONE 5: Factory/Upstream
    ['upstream', { id: 'upstream', x: 1750, y: 420, width: 250, height: 140, label: 'UPSTREAM FACTORY', color: 'rgba(155,93,229,0.5)', fillColor: 'rgba(155,93,229,0.08)' }],
    
    // ZONE 6: EDI & Retail (Column 10)
    ['retail', { id: 'retail', x: 2600, y: 150, width: 480, height: 250, label: 'RETAIL & EDI', color: 'rgba(255,159,28,0.5)', fillColor: 'rgba(255,159,28,0.08)' }],
    
    // ZONE 7: Integration & E-commerce (Columns 11-13)
    ['ecommerce', { id: 'ecommerce', x: 2600, y: 420, width: 800, height: 300, label: 'E-COMMERCE ECOSYSTEM', color: 'rgba(46,196,182,0.5)', fillColor: 'rgba(46,196,182,0.06)' }],
    
    // ZONE 8: Internal Tools (Bottom)
    ['internal', { id: 'internal', x: 1410, y: 650, width: 1000, height: 150, label: 'INTERNAL TOOLS', color: 'rgba(6,214,160,0.4)', fillColor: 'rgba(6,214,160,0.06)' }],
    
    // ZONE 9: Finance & Banking (Bottom)
    ['finance', { id: 'finance', x: 1410, y: 820, width: 1000, height: 140, label: 'FINANCE & BANKING', color: 'rgba(251,146,60,0.5)', fillColor: 'rgba(251,146,60,0.08)' }],
  ]);

  return { nodes, connections, zones };
};

const colorMap: Record<string, string> = {
  gold: 'rgba(255,209,102,0.8)',
  green: 'rgba(6,214,160,0.8)',
  teal: 'rgba(46,196,182,0.8)',
  amber: 'rgba(255,159,28,0.8)',
  purple: 'rgba(155,93,229,0.8)',
  orange: 'rgba(251,146,60,0.8)',
  blue: 'rgba(58,134,255,0.8)',
};

const colorOptions = [
  { value: 'gold', label: 'Gold' },
  { value: 'green', label: 'Green' },
  { value: 'teal', label: 'Teal' },
  { value: 'amber', label: 'Amber' },
  { value: 'purple', label: 'Purple' },
  { value: 'orange', label: 'Orange' },
  { value: 'blue', label: 'Blue' },
];

function getNodeColor(type: string) {
  switch(type) {
    case 'central': return '#ffd166';
    case 'live': return '#06d6a0';
    case 'building': return '#ff9f1c';
    case 'planned': return '#3a86ff';
    case 'legacy': return '#445566';
    case 'loose': return '#fb923c';
    case 'child': return '#2ec4b6';
    case 'third-party': return '#9b5de5';
    default: return '#566080';
  }
}

function getNodeBg(type: string) {
  if (type === 'central') return 'linear-gradient(135deg, #0c1838 0%, #0f2045 100%)';
  return '#0d1125';
}

function getNodeGlow(type: string) {
  if (type === 'central') return '0 0 50px rgba(255,209,102,0.2), 0 0 100px rgba(255,209,102,0.1)';
  if (type === 'building') return '0 0 20px rgba(255,159,28,0.3)';
  return 'none';
}

// Animated dots component
const AnimatedDot = ({ path, color, delay }: { path: string; color: string; delay: number }) => (
  <circle r="3" fill={color} opacity="0.8">
    <animateMotion dur="1.5s" repeatCount="indefinite" begin={`${delay}s`} path={path} />
  </circle>
);

// Generate unique ID
const genId = (prefix: string) => `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).substr(2, 5)}`;

function App() {
  const [viewport, setViewport] = useState({ x: 100, y: 50, zoom: 0.35 });
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [selectedType, setSelectedType] = useState<'node' | 'zone' | 'connection' | null>(null);
  const [draggedNode, setDraggedNode] = useState<string | null>(null);
  const [nodeState, setNodeState] = useState<Map<string, any>>(new Map());
  const [connectionState, setConnectionState] = useState<Map<string, any>>(new Map());
  const [zoneState, setZoneState] = useState<Map<string, any>>(new Map());
  const [gridEnabled, setGridEnabled] = useState(true);
  const [showHelp, setShowHelp] = useState(false);
  const [showAddNode, setShowAddNode] = useState(false);
  const [showAddConnection, setShowAddConnection] = useState(false);
  const [connectionStartNode, setConnectionStartNode] = useState<string | null>(null);
  const [spaceHeld, setSpaceHeld] = useState(false);
  const [toast, setToast] = useState<string | null>(null);
  const canvasRef = useRef<HTMLDivElement>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const clickedOnNodeRef = useRef(false);

  // Toast notification helper
  const showToast = (msg: string) => {
    setToast(msg);
    setTimeout(() => setToast(null), 2000);
  };

  // Initialize data - try to load from localStorage first
  useEffect(() => {
    const saved = localStorage.getItem('mindmap-studio-data');
    if (saved) {
      try {
        const data = JSON.parse(saved);
        if (data.nodes) setNodeState(new Map(data.nodes));
        if (data.connections) setConnectionState(new Map(data.connections));
        if (data.zones) setZoneState(new Map(data.zones));
        if (data.viewport) setViewport(data.viewport);
        console.log('Loaded from localStorage');
        return;
      } catch (e) {
        console.error('Failed to load from localStorage');
      }
    }
    // Load default ecosystem
    const { nodes, connections, zones } = createFullEcosystem();
    setNodeState(nodes);
    setConnectionState(connections);
    setZoneState(zones);
  }, []);

  // Auto-save to localStorage whenever data changes
  useEffect(() => {
    if (nodeState.size === 0) return; // Don't save before init
    const data = {
      nodes: Array.from(nodeState.entries()),
      connections: Array.from(connectionState.entries()),
      zones: Array.from(zoneState.entries()),
      viewport,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('mindmap-studio-data', JSON.stringify(data));
  }, [nodeState, connectionState, zoneState, viewport]);

  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) return;
      
      // Track space key for panning
      if (e.code === 'Space' && !spaceHeld) {
        e.preventDefault();
        setSpaceHeld(true);
        return;
      }
      
      switch(e.key) {
        case 'Escape': 
          setSelectedId(null); 
          setSelectedType(null);
          setConnectionStartNode(null);
          break;
        case 'Delete': 
          if (selectedId && selectedType === 'node') {
            setNodeState(prev => {
              const next = new Map(prev);
              next.delete(selectedId);
              return next;
            });
            // Also delete related connections
            setConnectionState(prev => {
              const next = new Map(prev);
              Array.from(next.entries()).forEach(([id, conn]) => {
                if (conn.fromId === selectedId || conn.toId === selectedId) {
                  next.delete(id);
                }
              });
              return next;
            });
            setSelectedId(null);
            setSelectedType(null);
          } else if (selectedId && selectedType === 'connection') {
            setConnectionState(prev => {
              const next = new Map(prev);
              next.delete(selectedId);
              return next;
            });
            setSelectedId(null);
            setSelectedType(null);
          }
          break;
        case 'g': if (e.ctrlKey) { e.preventDefault(); setGridEnabled(!gridEnabled); } break;
        case '?': setShowHelp(true); break;
        case '+': case '=': setViewport(v => ({ ...v, zoom: Math.min(5, v.zoom * 1.1) })); break;
        case '-': setViewport(v => ({ ...v, zoom: Math.max(0.1, v.zoom * 0.9) })); break;
        case '0': setViewport({ x: 100, y: 50, zoom: 0.35 }); break;
        case 'n': if (e.ctrlKey) { e.preventDefault(); setShowAddNode(true); } break;
        case 's': 
          if (e.ctrlKey) { 
            e.preventDefault(); 
            if (e.shiftKey) {
              saveToFile(); // Ctrl+Shift+S = export to file
            } else {
              saveToLocalStorage(); // Ctrl+S = save to browser
            }
          } 
          break;
        case 'o': if (e.ctrlKey) { e.preventDefault(); fileInputRef.current?.click(); } break;
      }
    };
    
    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.code === 'Space') {
        setSpaceHeld(false);
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [gridEnabled, selectedId, selectedType, nodeState, connectionState, zoneState, spaceHeld]);

  // Global mouseup to clear all dragging states
  useEffect(() => {
    const handleGlobalMouseUp = () => {
      setDraggedNode(null);
      setDraggingZone(null);
      setResizingZone(null);
      clickedOnNodeRef.current = false;
    };
    window.addEventListener('mouseup', handleGlobalMouseUp);
    return () => window.removeEventListener('mouseup', handleGlobalMouseUp);
  }, []);

  const transform = `translate(${viewport.x}px, ${viewport.y}px) scale(${viewport.zoom})`;

  // Save to JSON file (export/download)
  const saveToFile = () => {
    const data = {
      nodes: Array.from(nodeState.entries()),
      connections: Array.from(connectionState.entries()),
      zones: Array.from(zoneState.entries()),
      viewport,
      timestamp: new Date().toISOString()
    };
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `mindmap-${new Date().toISOString().split('T')[0]}.json`;
    a.click();
    URL.revokeObjectURL(url);
    // Show feedback
    showToast('💾 Exported to file!');
  };

  // Manual save to localStorage
  const saveToLocalStorage = () => {
    const data = {
      nodes: Array.from(nodeState.entries()),
      connections: Array.from(connectionState.entries()),
      zones: Array.from(zoneState.entries()),
      viewport,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('mindmap-studio-data', JSON.stringify(data));
    showToast('✅ Saved to browser!');
  };

  // Load from JSON file
  const loadFromFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const data = JSON.parse(event.target?.result as string);
        if (data.nodes) setNodeState(new Map(data.nodes));
        if (data.connections) setConnectionState(new Map(data.connections));
        if (data.zones) setZoneState(new Map(data.zones));
        if (data.viewport) setViewport(data.viewport);
      } catch (err) {
        alert('Failed to load file: Invalid JSON');
      }
    };
    reader.readAsText(file);
    e.target.value = '';
  };

  // Add new node
  const addNode = (label: string, type: string, category: string, icon: string) => {
    const centerX = (-viewport.x + window.innerWidth / 2) / viewport.zoom - 80;
    const centerY = (-viewport.y + window.innerHeight / 2) / viewport.zoom - 40;
    const id = genId('node');
    const newNode = {
      id,
      type,
      x: centerX,
      y: centerY,
      width: 140,
      height: 70,
      label,
      category,
      icon,
      status: type
    };
    setNodeState(prev => {
      const next = new Map(prev);
      next.set(id, newNode);
      return next;
    });
    setSelectedId(id);
    setSelectedType('node');
    setShowAddNode(false);
  };

  // Add new connection
  const addConnection = (fromId: string, toId: string, color: string, label: string) => {
    const id = genId('conn');
    setConnectionState(prev => {
      const next = new Map(prev);
      next.set(id, {
        id,
        fromId,
        toId,
        color,
        width: 1.8,
        label: label || undefined,
        animated: false
      });
      return next;
    });
    setShowAddConnection(false);
    setConnectionStartNode(null);
  };

  // Update selected item
  const updateSelected = (updates: any) => {
    if (!selectedId || !selectedType) return;
    if (selectedType === 'node') {
      setNodeState(prev => {
        const next = new Map(prev);
        const node = next.get(selectedId);
        if (node) next.set(selectedId, { ...node, ...updates });
        return next;
      });
    } else if (selectedType === 'connection') {
      setConnectionState(prev => {
        const next = new Map(prev);
        const conn = next.get(selectedId);
        if (conn) next.set(selectedId, { ...conn, ...updates });
        return next;
      });
    } else if (selectedType === 'zone') {
      setZoneState(prev => {
        const next = new Map(prev);
        const zone = next.get(selectedId);
        if (zone) next.set(selectedId, { ...zone, ...updates });
        return next;
      });
    }
  };

  // Zone dragging and resizing
  const [draggingZone, setDraggingZone] = useState<string | null>(null);
  const [resizingZone, setResizingZone] = useState<{ id: string; handle: string } | null>(null);
  const dragStartRef = useRef({ x: 0, y: 0, zoneX: 0, zoneY: 0, zoneW: 0, zoneH: 0 });

  const selectedItem = selectedId && selectedType === 'node' ? nodeState.get(selectedId) :
                       selectedId && selectedType === 'connection' ? connectionState.get(selectedId) :
                       selectedId && selectedType === 'zone' ? zoneState.get(selectedId) : null;

  return (
    <div style={{ width: '100vw', height: '100vh', background: '#050810', overflow: 'hidden' }}>
      {/* Hidden file input for load */}
      <input ref={fileInputRef} type="file" accept=".json" style={{ display: 'none' }} onChange={loadFromFile} />

      {/* Toolbar */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: 50,
        background: 'rgba(9,12,28,0.95)', borderBottom: '1px solid rgba(255,255,255,0.1)',
        display: 'flex', alignItems: 'center', padding: '0 20px', zIndex: 1000
      }}>
        <span style={{ fontFamily: 'Rajdhani, sans-serif', fontSize: 18, fontWeight: 700, marginRight: 20 }}>
          MINDMAP <span style={{ color: '#e63946' }}>STUDIO</span>
        </span>
        
        <button onClick={() => setShowAddNode(true)} style={{
          padding: '6px 12px', margin: '0 4px',
          background: '#06d6a0', border: 'none', borderRadius: 4,
          color: '#050810', cursor: 'pointer', fontSize: 12, fontWeight: 600,
          fontFamily: 'JetBrains Mono, monospace'
        }}>+ Node</button>
        
        <button onClick={() => setShowAddConnection(true)} style={{
          padding: '6px 12px', margin: '0 4px',
          background: '#3a86ff', border: 'none', borderRadius: 4,
          color: 'white', cursor: 'pointer', fontSize: 12, fontWeight: 600,
          fontFamily: 'JetBrains Mono, monospace'
        }}>+ Arrow</button>
        
        <button onClick={saveToLocalStorage} style={{
          padding: '6px 12px', margin: '0 4px',
          background: '#06d6a0', border: 'none', borderRadius: 4,
          color: '#050810', cursor: 'pointer', fontSize: 12, fontWeight: 600,
          fontFamily: 'JetBrains Mono, monospace'
        }} title="Ctrl+S">💾 Save</button>
        
        <button onClick={() => {
          if (confirm('Reset to default map? This will clear your changes.')) {
            localStorage.removeItem('mindmap-studio-data');
            const { nodes, connections, zones } = createFullEcosystem();
            setNodeState(nodes);
            setConnectionState(connections);
            setZoneState(zones);
            showToast('🔄 Reset to default!');
          }
        }} style={{
          padding: '6px 12px', margin: '0 4px',
          background: 'rgba(230,57,70,0.3)', border: '1px solid #e63946', borderRadius: 4,
          color: '#e63946', cursor: 'pointer', fontSize: 12, fontWeight: 600,
          fontFamily: 'JetBrains Mono, monospace'
        }} title="Reset to default">🔄 Reset</button>
        
        <button onClick={saveToFile} style={{
          padding: '6px 12px', margin: '0 4px',
          background: '#ff9f1c', border: 'none', borderRadius: 4,
          color: '#050810', cursor: 'pointer', fontSize: 12, fontWeight: 600,
          fontFamily: 'JetBrains Mono, monospace'
        }} title="Ctrl+Shift+S">📥 Export</button>
        
        <button onClick={() => fileInputRef.current?.click()} style={{
          padding: '6px 12px', margin: '0 4px',
          background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)',
          borderRadius: 4, color: '#cdd8f2', cursor: 'pointer', fontSize: 12
        }} title="Ctrl+O">📂 Import</button>
        
        <div style={{ width: 1, height: 24, background: 'rgba(255,255,255,0.1)', margin: '0 8px' }} />
        
        <button onClick={() => setGridEnabled(!gridEnabled)} style={{
          padding: '6px 12px', margin: '0 4px',
          background: gridEnabled ? '#3a86ff' : 'rgba(255,255,255,0.1)',
          border: '1px solid rgba(255,255,255,0.2)', borderRadius: 4,
          color: 'white', cursor: 'pointer', fontSize: 12,
          fontFamily: 'JetBrains Mono, monospace'
        }}>Grid</button>
        
        <button onClick={() => setViewport(v => ({ ...v, zoom: v.zoom * 1.1 }))} style={{
          padding: '6px 12px', margin: '0 4px',
          background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)',
          borderRadius: 4, color: '#cdd8f2', cursor: 'pointer', fontSize: 12
        }}>+</button>
        
        <button onClick={() => setViewport(v => ({ ...v, zoom: v.zoom * 0.9 }))} style={{
          padding: '6px 12px', margin: '0 4px',
          background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)',
          borderRadius: 4, color: '#cdd8f2', cursor: 'pointer', fontSize: 12
        }}>-</button>
        
        <span style={{ marginLeft: 'auto', fontSize: 11, color: '#566080', fontFamily: 'JetBrains Mono, monospace' }}>
          {spaceHeld ? '✋ PAN MODE ' : ''}{Math.round(viewport.zoom * 100)}% | Ctrl+S: Save | Ctrl+Shift+S: Export | ?: Help
        </span>
      </div>

      {/* Properties Panel (right side) */}
      {selectedItem && (
        <div style={{
          position: 'fixed', top: 60, right: 10, width: 260,
          background: 'rgba(13,17,37,0.98)', border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: 8, padding: 16, zIndex: 1000, maxHeight: 'calc(100vh - 100px)',
          overflow: 'auto'
        }}>
          <h3 style={{ margin: '0 0 16px', fontFamily: 'Rajdhani, sans-serif', fontSize: 14, textTransform: 'uppercase' }}>
            {selectedType === 'node' ? '✏️ Edit Node' : selectedType === 'connection' ? '↔️ Edit Arrow' : '📦 Edit Zone'}
          </h3>
          
          {selectedType === 'node' && (
            <>
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Label</label>
                <input type="text" value={selectedItem.label} onChange={e => updateSelected({ label: e.target.value })}
                  style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }} />
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Category</label>
                <input type="text" value={selectedItem.category} onChange={e => updateSelected({ category: e.target.value })}
                  style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }} />
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Icon</label>
                <input type="text" value={selectedItem.icon} onChange={e => updateSelected({ icon: e.target.value })}
                  style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }} />
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Type</label>
                <select value={selectedItem.type} onChange={e => updateSelected({ type: e.target.value })}
                  style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }}>
                  <option value="live">Live</option>
                  <option value="central">Central</option>
                  <option value="building">Building</option>
                  <option value="planned">Planned</option>
                  <option value="legacy">Legacy</option>
                  <option value="loose">Loose</option>
                  <option value="child">Child</option>
                  <option value="third-party">Third Party</option>
                </select>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 12 }}>
                <div>
                  <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>X</label>
                  <input type="number" value={Math.round(selectedItem.x)} onChange={e => updateSelected({ x: parseInt(e.target.value) || 0 })}
                    style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Y</label>
                  <input type="number" value={Math.round(selectedItem.y)} onChange={e => updateSelected({ y: parseInt(e.target.value) || 0 })}
                    style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }} />
                </div>
              </div>
            </>
          )}
          
          {selectedType === 'connection' && (
            <>
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Label</label>
                <input type="text" value={selectedItem.label || ''} onChange={e => updateSelected({ label: e.target.value || undefined })}
                  style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }} />
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Color</label>
                <select value={selectedItem.color} onChange={e => updateSelected({ color: e.target.value })}
                  style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }}>
                  {colorOptions.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                </select>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Width</label>
                <input type="range" min="0.5" max="4" step="0.1" value={selectedItem.width} onChange={e => updateSelected({ width: parseFloat(e.target.value) })}
                  style={{ width: '100%' }} />
              </div>
              <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, cursor: 'pointer' }}>
                  <input type="checkbox" checked={selectedItem.animated} onChange={e => updateSelected({ animated: e.target.checked })} />
                  Animated
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, cursor: 'pointer' }}>
                  <input type="checkbox" checked={selectedItem.dashed} onChange={e => updateSelected({ dashed: e.target.checked })} />
                  Dashed
                </label>
              </div>
            </>
          )}
          
          {selectedType === 'zone' && (
            <>
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Label</label>
                <input type="text" value={selectedItem.label} onChange={e => updateSelected({ label: e.target.value })}
                  style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }} />
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Border Color</label>
                <input type="text" value={selectedItem.color} onChange={e => updateSelected({ color: e.target.value })}
                  style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }} />
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Fill Color</label>
                <input type="text" value={selectedItem.fillColor} onChange={e => updateSelected({ fillColor: e.target.value })}
                  style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 12 }}>
                <div>
                  <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>X</label>
                  <input type="number" value={Math.round(selectedItem.x)} onChange={e => updateSelected({ x: parseInt(e.target.value) || 0 })}
                    style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Y</label>
                  <input type="number" value={Math.round(selectedItem.y)} onChange={e => updateSelected({ y: parseInt(e.target.value) || 0 })}
                    style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Width</label>
                  <input type="number" value={Math.round(selectedItem.width)} onChange={e => updateSelected({ width: Math.max(50, parseInt(e.target.value) || 100) })}
                    style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Height</label>
                  <input type="number" value={Math.round(selectedItem.height)} onChange={e => updateSelected({ height: Math.max(50, parseInt(e.target.value) || 100) })}
                    style={{ width: '100%', padding: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 12 }} />
                </div>
              </div>
            </>
          )}
          
          <button onClick={() => { setSelectedId(null); setSelectedType(null); }} style={{
            width: '100%', padding: 8, background: 'rgba(230,57,70,0.2)', border: '1px solid #e63946',
            borderRadius: 4, color: '#e63946', cursor: 'pointer', fontSize: 12, marginTop: 8
          }}>Close / Deselect</button>
        </div>
      )}

      {/* Canvas */}
      <div 
        ref={canvasRef}
        style={{
          position: 'absolute', top: 50, left: 0, right: 0, bottom: 0,
          background: gridEnabled 
            ? 'radial-gradient(circle, rgba(255,255,255,0.05) 1px, transparent 1px)'
            : '#050810',
          backgroundSize: '20px 20px',
          cursor: spaceHeld ? 'grab' : 'default'
        }}
        onWheel={(e) => {
          if (e.ctrlKey) {
            e.preventDefault();
            const factor = e.deltaY < 0 ? 1.1 : 0.9;
            setViewport(v => ({ ...v, zoom: Math.max(0.1, Math.min(5, v.zoom * factor)) }));
          }
        }}
        onMouseDown={(e) => {
          // Pan with: middle-click OR shift+drag OR space+drag
          const shouldPan = e.button === 1 || (e.button === 0 && (e.shiftKey || spaceHeld));
          if (shouldPan && !clickedOnNodeRef.current && !draggingZone && !resizingZone) {
            e.preventDefault();
            const startX = e.clientX;
            const startY = e.clientY;
            const startVX = viewport.x;
            const startVY = viewport.y;
            
            const handleMove = (e2: MouseEvent) => {
              setViewport({
                ...viewport,
                x: startVX + (e2.clientX - startX),
                y: startVY + (e2.clientY - startY)
              });
            };
            
            const handleUp = () => {
              window.removeEventListener('mousemove', handleMove);
              window.removeEventListener('mouseup', handleUp);
            };
            
            window.addEventListener('mousemove', handleMove);
            window.addEventListener('mouseup', handleUp);
          }
        }}
        onClick={(e) => {
          // Only deselect if clicking on empty canvas (not on node/zone/connection)
          if (e.target === e.currentTarget && !clickedOnNodeRef.current && !draggingZone && !resizingZone) {
            setSelectedId(null);
            setSelectedType(null);
          }
          // Reset the ref after click processing
          setTimeout(() => { clickedOnNodeRef.current = false; }, 0);
        }}
      >
        <div style={{ transform, transformOrigin: '0 0', position: 'relative' }}>
          {/* Zones with drag and resize */}
          {Array.from(zoneState.values()).map(zone => {
            const isSelected = selectedId === zone.id && selectedType === 'zone';
            return (
              <div 
                key={zone.id} 
                onMouseDown={(e) => {
                  // Don't select zone if we're clicking on a node (nodes have higher z-index)
                  // This shouldn't fire if we're on a node due to z-index, but just in case
                  if (clickedOnNodeRef.current) return;
                  e.stopPropagation();
                  setSelectedId(zone.id);
                  setSelectedType('zone');
                  // Start dragging
                  setDraggingZone(zone.id);
                  dragStartRef.current = { 
                    x: e.clientX, y: e.clientY, 
                    zoneX: zone.x, zoneY: zone.y,
                    zoneW: zone.width, zoneH: zone.height
                  };
                }}
                onMouseMove={(e) => {
                  if (draggingZone === zone.id) {
                    const dx = (e.clientX - dragStartRef.current.x) / viewport.zoom;
                    const dy = (e.clientY - dragStartRef.current.y) / viewport.zoom;
                    setZoneState(prev => {
                      const next = new Map(prev);
                      const z = next.get(zone.id);
                      if (z) next.set(zone.id, { ...z, x: dragStartRef.current.zoneX + dx, y: dragStartRef.current.zoneY + dy });
                      return next;
                    });
                  }
                  if (resizingZone?.id === zone.id) {
                    const dx = (e.clientX - dragStartRef.current.x) / viewport.zoom;
                    const dy = (e.clientY - dragStartRef.current.y) / viewport.zoom;
                    setZoneState(prev => {
                      const next = new Map(prev);
                      const z = next.get(zone.id);
                      if (!z) return prev;
                      let updates: any = {};
                      const handle = resizingZone.handle;
                      if (handle.includes('e')) updates.width = Math.max(50, dragStartRef.current.zoneW + dx);
                      if (handle.includes('w')) {
                        const newW = Math.max(50, dragStartRef.current.zoneW - dx);
                        updates.width = newW;
                        updates.x = dragStartRef.current.zoneX + (dragStartRef.current.zoneW - newW);
                      }
                      if (handle.includes('s')) updates.height = Math.max(50, dragStartRef.current.zoneH + dy);
                      if (handle.includes('n')) {
                        const newH = Math.max(50, dragStartRef.current.zoneH - dy);
                        updates.height = newH;
                        updates.y = dragStartRef.current.zoneY + (dragStartRef.current.zoneH - newH);
                      }
                      next.set(zone.id, { ...z, ...updates });
                      return next;
                    });
                  }
                }}
                onMouseUp={() => {
                  // Clear dragging state after a short delay to avoid race conditions
                  setTimeout(() => {
                    setDraggingZone(null);
                    setResizingZone(null);
                  }, 0);
                }}
                style={{
                  position: 'absolute', left: zone.x, top: zone.y,
                  width: zone.width, height: zone.height,
                  background: zone.fillColor, 
                  border: `2px solid ${isSelected ? '#3a86ff' : zone.color}`,
                  borderRadius: 14, 
                  cursor: draggingZone === zone.id ? 'grabbing' : 'grab',
                  boxShadow: isSelected ? '0 0 20px rgba(58,134,255,0.4)' : 'none',
                  zIndex: isSelected ? 5 : 1
                }}
              >
                <span style={{
                  position: 'absolute', top: -25, left: '50%', transform: 'translateX(-50%)',
                  fontFamily: 'JetBrains Mono, monospace', fontSize: 10,
                  color: isSelected ? '#3a86ff' : zone.color, 
                  textTransform: 'uppercase', letterSpacing: '0.1em',
                  whiteSpace: 'nowrap'
                }}>{zone.label}</span>
                
                {/* Resize handles - only show when selected */}
                {isSelected && (
                  <>
                    {/* Corner handles */}
                    {['nw', 'ne', 'sw', 'se'].map(pos => {
                      const styles: any = {
                        position: 'absolute',
                        width: 10, height: 10,
                        background: '#3a86ff',
                        border: '2px solid #fff',
                        borderRadius: '50%',
                        cursor: pos === 'nw' ? 'nw-resize' : pos === 'ne' ? 'ne-resize' : pos === 'sw' ? 'sw-resize' : 'se-resize',
                        zIndex: 10
                      };
                      if (pos.includes('n')) styles.top = -5;
                      if (pos.includes('s')) styles.bottom = -5;
                      if (pos.includes('w')) styles.left = -5;
                      if (pos.includes('e')) styles.right = -5;
                      return (
                        <div
                          key={pos}
                          style={styles}
                          onMouseDown={(e) => {
                            e.stopPropagation();
                            setResizingZone({ id: zone.id, handle: pos });
                            dragStartRef.current = { 
                              x: e.clientX, y: e.clientY, 
                              zoneX: zone.x, zoneY: zone.y,
                              zoneW: zone.width, zoneH: zone.height
                            };
                          }}
                        />
                      );
                    })}
                    {/* Edge handles */}
                    {['n', 's', 'e', 'w'].map(pos => {
                      const styles: any = {
                        position: 'absolute',
                        background: '#3a86ff',
                        border: '1px solid #fff',
                        zIndex: 10
                      };
                      if (pos === 'n' || pos === 's') {
                        styles.width = 20; styles.height = 6;
                        styles.left = '50%'; styles.transform = 'translateX(-50%)';
                        styles.cursor = 'ns-resize';
                      } else {
                        styles.width = 6; styles.height = 20;
                        styles.top = '50%'; styles.transform = 'translateY(-50%)';
                        styles.cursor = 'ew-resize';
                      }
                      if (pos === 'n') styles.top = -3;
                      if (pos === 's') styles.bottom = -3;
                      if (pos === 'w') styles.left = -3;
                      if (pos === 'e') styles.right = -3;
                      return (
                        <div
                          key={pos}
                          style={styles}
                          onMouseDown={(e) => {
                            e.stopPropagation();
                            setResizingZone({ id: zone.id, handle: pos });
                            dragStartRef.current = { 
                              x: e.clientX, y: e.clientY, 
                              zoneX: zone.x, zoneY: zone.y,
                              zoneW: zone.width, zoneH: zone.height
                            };
                          }}
                        />
                      );
                    })}
                  </>
                )}
              </div>
            );
          })}

          {/* Connections SVG with clickable paths */}
          <svg style={{ position: 'absolute', inset: 0, width: 3500, height: 1000, pointerEvents: 'none', overflow: 'visible' }}>
            <defs>
              {Object.entries(colorMap).map(([color, value]) => (
                <marker key={color} id={`arrow-${color}`} markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
                  <polygon points="0 0, 0 7, 7 3.5" fill={value} />
                </marker>
              ))}
              <filter id="glow">
                <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
                <feMerge>
                  <feMergeNode in="coloredBlur"/>
                  <feMergeNode in="SourceGraphic"/>
                </feMerge>
              </filter>
            </defs>
            
            {Array.from(connectionState.values()).map(conn => {
              const from = nodeState.get(conn.fromId);
              const to = nodeState.get(conn.toId);
              if (!from || !to) return null;
              
              const fx = from.x + from.width / 2;
              const fy = from.y + from.height / 2;
              const tx = to.x + to.width / 2;
              const ty = to.y + to.height / 2;
              const mx = (fx + tx) / 2;
              const my = (fy + ty) / 2;
              const pathStr = `M ${fx} ${fy} Q ${mx} ${fy} ${tx} ${ty}`;
              const isSelected = selectedId === conn.id && selectedType === 'connection';
              
              return (
                <g key={conn.id} style={{ pointerEvents: 'all', cursor: 'pointer' }} onClick={(e) => {
                  e.stopPropagation();
                  setSelectedId(conn.id);
                  setSelectedType('connection');
                }}>
                  {/* Invisible wider path for easier clicking */}
                  <path d={pathStr} stroke="transparent" strokeWidth="15" fill="none" />
                  <path
                    d={pathStr}
                    stroke={isSelected ? '#3a86ff' : (colorMap[conn.color] || '#2ec4b6')}
                    strokeWidth={isSelected ? (conn.width + 1) : conn.width}
                    fill="none"
                    strokeDasharray={conn.dashed ? '5,5' : 'none'}
                    markerEnd={`url(#arrow-${conn.color})`}
                    filter={conn.animated ? 'url(#glow)' : 'none'}
                    style={{ opacity: 0.9 }}
                  />
                  {conn.label && (
                    <text x={mx} y={my - 10} textAnchor="middle" fill={isSelected ? '#3a86ff' : colorMap[conn.color]} 
                          fontSize="8" fontFamily="JetBrains Mono, monospace" fontWeight="600">
                      {conn.label}
                    </text>
                  )}
                  {conn.animated && (
                    <>
                      <AnimatedDot path={pathStr} color={colorMap[conn.color]} delay={0} />
                      <AnimatedDot path={pathStr} color={colorMap[conn.color]} delay={0.5} />
                    </>
                  )}
                </g>
              );
            })}
          </svg>

          {/* Nodes */}
          {Array.from(nodeState.values()).map(node => (
            <div
              key={node.id}
              style={{
                position: 'absolute', left: node.x, top: node.y,
                width: node.width, height: node.height,
                background: getNodeBg(node.type),
                border: `1px solid ${selectedId === node.id && selectedType === 'node' ? '#3a86ff' : 'rgba(255,255,255,0.1)'}`,
                borderLeft: `3px solid ${getNodeColor(node.type)}`,
                borderRadius: 9, padding: '10px 13px',
                cursor: draggedNode === node.id ? 'grabbing' : 'grab',
                boxShadow: selectedId === node.id && selectedType === 'node' ? '0 0 0 2px #3a86ff, 0 0 20px rgba(58,134,255,0.3)' : getNodeGlow(node.type),
                zIndex: 10, opacity: node.type === 'legacy' ? 0.65 : 1,
                transition: 'transform 0.1s, box-shadow 0.2s'
              }}
              onMouseDown={(e) => {
                e.stopPropagation();
                clickedOnNodeRef.current = true;
                setSelectedId(node.id);
                setSelectedType('node');
                setDraggedNode(node.id);
              }}
              onMouseMove={(e) => {
                if (draggedNode === node.id) {
                  const dx = e.movementX / viewport.zoom;
                  const dy = e.movementY / viewport.zoom;
                  setNodeState(prev => {
                    const next = new Map(prev);
                    const n = next.get(node.id);
                    if (n) next.set(node.id, { ...n, x: n.x + dx, y: n.y + dy });
                    return next;
                  });
                }
              }}
              onMouseUp={() => {
                setDraggedNode(null);
                // Clear the ref after a short delay to prevent race conditions
                setTimeout(() => { clickedOnNodeRef.current = false; }, 50);
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLDivElement).style.transform = 'none';
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                {node.icon && <span style={{ fontSize: 15 }}>{node.icon}</span>}
                <span style={{ 
                  fontFamily: 'Rajdhani, sans-serif', fontSize: node.type === 'central' ? 16 : 14, 
                  fontWeight: 600, color: node.type === 'central' ? '#ffd166' : '#cdd8f2'
                }}>{node.label}</span>
              </div>
              {node.category && (
                <span style={{ 
                  fontFamily: 'JetBrains Mono, monospace', fontSize: 8, 
                  opacity: 0.6, textTransform: 'uppercase', display: 'block', marginTop: 4,
                  color: node.type === 'central' ? 'rgba(255,209,102,0.8)' : 'inherit'
                }}>{node.category}</span>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Status Bar */}
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, height: 30,
        background: 'rgba(9,12,28,0.95)', borderTop: '1px solid rgba(255,255,255,0.1)',
        display: 'flex', alignItems: 'center', padding: '0 20px', zIndex: 1000,
        fontSize: 11, color: '#566080', fontFamily: 'JetBrains Mono, monospace'
      }}>
        <span>Nodes: {nodeState.size}</span>
        <span style={{ marginLeft: 20 }}>Connections: {connectionState.size}</span>
        <span style={{ marginLeft: 20 }}>Zones: {zoneState.size}</span>
        <span style={{ marginLeft: 20 }}>Selected: {selectedType ? `${selectedType} (${selectedId?.slice(0, 8)}...)` : 'none'}</span>
        <span style={{ marginLeft: 'auto' }}>✓ Full Daiwa Ecosystem Loaded</span>
      </div>

      {/* Add Node Modal */}
      {showAddNode && (
        <Modal onClose={() => setShowAddNode(false)} title="Add New Node">
          <AddNodeForm onAdd={addNode} onCancel={() => setShowAddNode(false)} />
        </Modal>
      )}

      {/* Add Connection Modal */}
      {showAddConnection && (
        <Modal onClose={() => setShowAddConnection(false)} title="Add New Arrow">
          <AddConnectionForm 
            nodes={Array.from(nodeState.values())} 
            onAdd={addConnection} 
            onCancel={() => setShowAddConnection(false)} 
          />
        </Modal>
      )}

      {/* Help Modal */}
      {showHelp && (
        <Modal onClose={() => setShowHelp(false)} title="Keyboard Shortcuts">
          <table style={{ fontSize: 13, fontFamily: 'JetBrains Mono, monospace', width: '100%' }}>
            <tbody>
              {[
                ['?', 'Show this help'],
                ['Delete', 'Remove selected node/arrow'],
                ['Ctrl+N', 'Add new node'],
                ['Ctrl+S', 'Save to browser (auto)'],
                ['Ctrl+Shift+S', 'Export to file'],
                ['Ctrl+O', 'Import from file'],
                ['Ctrl+G', 'Toggle grid'],
                ['+ / -', 'Zoom in/out'],
                ['0', 'Reset view'],
                ['Space + Drag', 'Pan canvas (hold space)'],
                ['Shift + Drag', 'Pan canvas'],
                ['Middle Click + Drag', 'Pan canvas'],
                ['Drag nodes', 'Move them (arrows follow)'],
                ['Click arrow', 'Select and edit arrow'],
                ['Click zone', 'Select zone box'],
                ['Esc', 'Deselect all'],
              ].map(([key, desc]) => (
                <tr key={key}>
                  <td style={{ padding: '6px 20px 6px 0', color: '#3a86ff', fontWeight: 600 }}>{key}</td>
                  <td style={{ padding: '6px 0', color: '#cdd8f2' }}>{desc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal>
      )}

      {/* Toast Notification */}
      {toast && (
        <div style={{
          position: 'fixed', bottom: 40, left: '50%', transform: 'translateX(-50%)',
          background: '#06d6a0', color: '#050810', padding: '10px 24px',
          borderRadius: 8, fontFamily: 'JetBrains Mono, monospace', fontSize: 14,
          fontWeight: 600, zIndex: 10000, animation: 'fade-in 0.2s ease'
        }}>
          {toast}
        </div>
      )}
    </div>
  );
}

// Modal component
function Modal({ children, onClose, title }: { children: React.ReactNode; onClose: () => void; title: string }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000
    }} onClick={onClose}>
      <div style={{
        background: '#0d1125', border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 12, padding: 24, minWidth: 300, maxWidth: 400
      }} onClick={e => e.stopPropagation()}>
        <h2 style={{ margin: '0 0 20px', fontFamily: 'Rajdhani, sans-serif' }}>{title}</h2>
        {children}
      </div>
    </div>
  );
}

// Add Node Form
function AddNodeForm({ onAdd, onCancel }: { onAdd: (label: string, type: string, category: string, icon: string) => void; onCancel: () => void }) {
  const [label, setLabel] = useState('');
  const [type, setType] = useState('live');
  const [category, setCategory] = useState('');
  const [icon, setIcon] = useState('📦');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (label.trim()) {
      onAdd(label.trim(), type, category.trim() || 'Custom', icon);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Label *</label>
        <input type="text" value={label} onChange={e => setLabel(e.target.value)} autoFocus
          style={{ width: '100%', padding: 8, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 13 }} />
      </div>
      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Type</label>
        <select value={type} onChange={e => setType(e.target.value)}
          style={{ width: '100%', padding: 8, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 13 }}>
          <option value="live">Live</option>
          <option value="central">Central</option>
          <option value="building">Building</option>
          <option value="planned">Planned</option>
          <option value="legacy">Legacy</option>
          <option value="loose">Loose</option>
          <option value="child">Child</option>
          <option value="third-party">Third Party</option>
        </select>
      </div>
      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Category</label>
        <input type="text" value={category} onChange={e => setCategory(e.target.value)}
          style={{ width: '100%', padding: 8, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 13 }} />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Icon</label>
        <input type="text" value={icon} onChange={e => setIcon(e.target.value)}
          style={{ width: '100%', padding: 8, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 13 }} />
      </div>
      <div style={{ display: 'flex', gap: 10 }}>
        <button type="submit" style={{ flex: 1, padding: 10, background: '#06d6a0', border: 'none', borderRadius: 4, color: '#050810', fontWeight: 600, cursor: 'pointer' }}>Add Node</button>
        <button type="button" onClick={onCancel} style={{ flex: 1, padding: 10, background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 4, color: '#cdd8f2', cursor: 'pointer' }}>Cancel</button>
      </div>
    </form>
  );
}

// Add Connection Form
function AddConnectionForm({ nodes, onAdd, onCancel }: { nodes: any[], onAdd: (fromId: string, toId: string, color: string, label: string) => void; onCancel: () => void }) {
  const [fromId, setFromId] = useState('');
  const [toId, setToId] = useState('');
  const [color, setColor] = useState('green');
  const [label, setLabel] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (fromId && toId && fromId !== toId) {
      onAdd(fromId, toId, color, label.trim());
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>From Node *</label>
        <select value={fromId} onChange={e => setFromId(e.target.value)}
          style={{ width: '100%', padding: 8, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 13 }}>
          <option value="">Select source node...</option>
          {nodes.map(n => <option key={n.id} value={n.id}>{n.icon} {n.label}</option>)}
        </select>
      </div>
      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>To Node *</label>
        <select value={toId} onChange={e => setToId(e.target.value)}
          style={{ width: '100%', padding: 8, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 13 }}>
          <option value="">Select target node...</option>
          {nodes.map(n => <option key={n.id} value={n.id}>{n.icon} {n.label}</option>)}
        </select>
      </div>
      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Color</label>
        <select value={color} onChange={e => setColor(e.target.value)}
          style={{ width: '100%', padding: 8, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 13 }}>
          {colorOptions.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
        </select>
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: 10, color: '#566080', marginBottom: 4, textTransform: 'uppercase' }}>Label (optional)</label>
        <input type="text" value={label} onChange={e => setLabel(e.target.value)} placeholder="e.g., SYNC"
          style={{ width: '100%', padding: 8, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 4, color: '#cdd8f2', fontSize: 13 }} />
      </div>
      <div style={{ display: 'flex', gap: 10 }}>
        <button type="submit" style={{ flex: 1, padding: 10, background: '#3a86ff', border: 'none', borderRadius: 4, color: 'white', fontWeight: 600, cursor: 'pointer' }}>Add Arrow</button>
        <button type="button" onClick={onCancel} style={{ flex: 1, padding: 10, background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 4, color: '#cdd8f2', cursor: 'pointer' }}>Cancel</button>
      </div>
    </form>
  );
}

export default App;
